import Splide from "@splidejs/splide";

Splide.defaults = {};

(function () {
    const sliders = document.getElementsByClassName("splide");

    for (let i = 0; i < sliders.length; i++) {
        let slider = sliders[i];

        // Prevent duplicate initialization by "data-splide-sync"
        if (slider.Splide || slider.classList.contains("splide--no-init")) {
            continue;
        }

        let splide = new Splide(slider);
        let extensions = {};

        slider.Splide = splide;

        let slidersToSync = [];
        if (slider.getAttribute("data-splide-sync")) {
            slidersToSync = document.querySelectorAll(slider.getAttribute("data-splide-sync"));
        }

        slidersToSync.forEach((sliderToSync) => {
            let sync = new Splide(sliderToSync);
            splide.sync(sync);
            sliderToSync.Splide = sync;
        });

        splide.mount(extensions);

        slidersToSync.forEach((sliderToSync) => {
            sliderToSync.Splide.mount(extensions);
        });
    }
})();
